module.exports = __webpack_public_path__ + "img/svg/banner-card-mobile.c2091819627076ae5547fabce37d2e72.svg";